module.exports = __webpack_public_path__ + "img/tpc-printable-flyers-3.4ea496a7.jpg";